import { AfterViewInit, Component, OnDestroy, OnInit,ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { ApiServiceEjecutive } from '../../../apis/ApiServiceEjecutive';
import Swal from 'sweetalert2';
import { FormatDataTableScroll, FormatDataTableScrollOne, FormatDataTableScrollTwo } from '../../../util/formatDataTable';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-pending-payment-train-detail',
  templateUrl: './pending-payment-train-detail.component.html',
  styleUrls: ['./pending-payment-train-detail.component.scss']
})
export class PendingPaymentTrainDetailComponent implements OnInit {

 @ViewChild(DataTableDirective, {static: false})
    dtElement: DataTableDirective;
    dtTrigger = new Subject();
    dtOptions: DataTables.Settings = {};
    formSearch:FormGroup
    listInfOption = [];
    listInfoPlay = [];
    listFilterClient = [];
    listPlayOption = [];
  
  
    dropdownSettings = {};
    filterOperation = [];
    filterComercialOrigen = [];
    typeMoney = ""
    listTypeService = [];
  
    years: number[] = [];
    currentYear: number;
 
    months: string[] = [
     'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
     'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
   ];
  
    constructor(
      private fb: FormBuilder,
      private spinner: NgxSpinnerService,
      private errorService:ErrorService,
      private apiService: ApiServiceEjecutive) { 
  
    }
  
    ngOnInit(): void {
 
     
     const startYear = 2017;
     const endYear = new Date().getFullYear() + 2; // Año actual + 2 (2027)
     
     this.years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
     this.currentYear = new Date().getFullYear();
 
 
 
      this.formSearch = this.fb.group({
        year:0,
        optionClient:0,
        selectComercialOrigen: 0,
        currencyTransf: 0,
        });
  
        if (localStorage.getItem("info-pdg-pending-payment-train-detail") ){
            let rs = JSON.parse(localStorage.getItem("info-pdg-pending-payment-train-detail"));
            this.currentYear = rs.year
            this.formSearch.patchValue(rs);
            
        }
  
      this.dtOptions = FormatDataTableScrollTwo(); 
      this.iniService()
    }
  
    iniService(){
  
  
      let infoModeny = this.formSearch.value.currencyTransf
      if(infoModeny == 0){
        infoModeny = "2"
      }
      let year = this.formSearch.value.year
      if(year == 0){
       year = new Date().getFullYear()
     }
     let selectComercialOrigen = this.formSearch.value.selectComercialOrigen
     if(selectComercialOrigen == 0){
       selectComercialOrigen = ''
    }
    this.currentYear = year
      this.spinner.show();
      this.apiService.getService('list-payment-train-non-paying-project?year='+year+'&commercialOrigin='+selectComercialOrigen+'&clientId='+this.formSearch.value.optionClient+'&currencyTransf='+infoModeny+'')
      .subscribe({
        next: (rs: any) => {
        if (rs.code == null) {
  
         this.listInfoPlay = rs.listInfoData
         this.filterComercialOrigen = rs.listCommercialOrigin
         this.listFilterClient = rs.listFilterClient
         this.listPlayOption = rs.listPlayOption
  
        this.spinner.hide();
  
        this.rerender();
  
  
      let type = this.listPlayOption.filter( n =>  n.id ==  this.formSearch.value.currencyTransf)
      if(type[0] != null){
        this.typeMoney = type[0].name
      }else{
        this.typeMoney = "UF"
      }
  
        } else {
          this.spinner.hide();
          Swal.fire({
            title:  rs.error,
            text: '',
            icon: 'error',
            heightAuto: false
            });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });
    }
  
  
  
    ngAfterViewInit(): void {
      
    }
  
    limpButton(){
     localStorage.removeItem("info-pdg-pending-payment-train-detail")
      location.replace(`/pdg/finance/pending-payment-train-detail`)
        
    }
  
    formSubmit(){
 
        let inf = {
         year:this.formSearch.value.year,
         optionClient:this.formSearch.value.optionClient,
         selectComercialOrigen: this.formSearch.value.selectComercialOrigen,
         currencyTransf: this.formSearch.value.currencyTransf,
        }
  
        localStorage.setItem("info-pdg-pending-payment-train-detail", JSON.stringify(inf));
        location.replace(`/pdg/finance/pending-payment-train-detail`)
  
    }
  
 
    downloadButton(){
        Swal.fire({
          title: 'Descargar',
          text: '¿Desea descargar el archivo?',
          icon: 'warning',
          showCancelButton:true,
          confirmButtonText: 'Descargar',
          cancelButtonText:"No, cancelar",
          heightAuto: false
        }).then((res) => {
          if (res.isConfirmed) {
    
           let infoModeny = this.formSearch.value.currencyTransf
           if(infoModeny == 0){
             infoModeny = "2"
           }
           let year = this.formSearch.value.year
           if(year == 0){
            year = new Date().getFullYear()
          }
          let selectComercialOrigen = this.formSearch.value.selectComercialOrigen
          if(selectComercialOrigen == 0){
            selectComercialOrigen = ''
         }
        
           this.spinner.show();
           let urlInfo = 'dowload-document-excel-payment-train?year='+year+'&commercialOrigin='+selectComercialOrigen+'&clientId='+this.formSearch.value.optionClient+'&currencyTransf='+infoModeny+'&type=2'
           
           this.spinner.show()
           this.apiService.DownloadService(urlInfo).subscribe({
              next: (rs: any) => {
                  let dataType = rs.type;
                  let ext = dataType.split('/')
                  let binaryData = [];
                  binaryData.push(rs);
                  let downloadLink = document.createElement('a');
                  downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
                  if(ext[1] != null){
                    downloadLink.setAttribute('download','document.'+ext[1]);
                  }
                  this.spinner.hide();
                  document.body.appendChild(downloadLink);
                  downloadLink.click();
              },
              error: (error) => {
                const errorJson = JSON.parse(this.blobToString(error.error));
                if(errorJson.code == 1){
                  this.spinner.hide()
                  Swal.fire({title:errorJson.error,text: '',icon: 'error',heightAuto: false});
                }else{
                  this.errorService.error(error);
                }
              },})
          }
          else if ( res.dismiss === Swal.DismissReason.cancel){
            Swal.fire({
              title: 'Cancelado',
              text: 'Operación cancelada.',
              icon: 'error',
              heightAuto: false
            })
    
          }
        });
      }
 
  
 
   private blobToString(blob): string {
     const url = URL.createObjectURL(blob);
     let xmlRequest = new XMLHttpRequest();
     xmlRequest.open('GET', url, false);
     xmlRequest.send();
     URL.revokeObjectURL(url);
     return xmlRequest.responseText;
 }
 
    ngOnDestroy(): void {
     localStorage.removeItem("info-pdg-pending-payment-train-detail")
      this.dtTrigger.unsubscribe();
    }
  
    rerender(): void {
      this.dtTrigger.next();
    }
  }
  
  
  